module.exports = __webpack_public_path__ + "static/media/step-3.8a60cae6.png";